import { FormItem } from 'components/Base/Form/FormItem';
import Form, { validationRules } from 'components/Base/Form';
import VerificationCode from 'components/Base/VerificationCode';
import {
  EFormIds,
  TVerificationFormProps,
} from 'pages/public/Login/Login.types';

const SignForm = ({ form }: TVerificationFormProps) => {
  return (
    <Form
      form={form}
      name="basic"
      autoComplete="off"
      id={EFormIds.VERIFICATION}
    >
      <FormItem
        className="verification-code-wrapper"
        name="verificationCode"
        rules={[validationRules.verificationCode()]}
      >
        <VerificationCode />
      </FormItem>
    </Form>
  );
};

export default SignForm;
